import { openModal } from "./modal";

export function showEndModal(title: string, subtitle: string, onRematch: () => void): void {
  const content = document.createElement("div");
  content.innerHTML = `
    <h2 class="title-display">${title}</h2>
    <p class="result-banner">${subtitle}</p>
    <div class="menu-actions">
      <button class="btn btn-primary" id="rematch-btn" type="button">Nouvelle partie</button>
    </div>
  `;
  const { close } = openModal(content, { dismissible: false });
  content.querySelector<HTMLButtonElement>("#rematch-btn")?.addEventListener("click", () => {
    close();
    onRematch();
  });
}
